import { useState } from 'react'
import Swal from 'sweetalert2'
import CustomerService from '@/services/CustomerService'
import { useTranslation } from 'react-i18next'

export function useCustomerActions(loadCustomerData) {
	const { t } = useTranslation()
	const [isDeleting, setIsDeleting] = useState(false)

	const handleDeleteSelected = async (selectedCustomers, clearSelection) => {
		if (selectedCustomers.size === 0) {
			Swal.fire({
				title: t('customers.list.deleteDialog.noneSelectedTitle'),
				text: t('customers.list.deleteDialog.noneSelectedText'),
				icon: 'warning',
			})
			return
		}

		const result = await Swal.fire({
			title: t('customers.list.deleteDialog.confirmTitle'),
			text: t('customers.list.deleteDialog.confirmText', { count: selectedCustomers.size }),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			confirmButtonText: t('customers.list.deleteDialog.confirmButton'),
			cancelButtonText: t('customers.list.deleteDialog.cancelButton'),
		})

		if (result.isConfirmed) {
			setIsDeleting(true)
			try {
				const customerIds = Array.from(selectedCustomers)
				const deleteResult = await CustomerService.deleteCustomers(customerIds)

				if (deleteResult.success) {
					// Clear selection and reload data
					clearSelection()
					loadCustomerData()
				} else {
					Swal.fire({
						title: t('customers.list.deleteDialog.errorTitle'),
						text: deleteResult.error || t('customers.list.deleteDialog.errorFallback'),
						icon: 'error',
					})
				}
			} catch (error) {
				console.error('Delete customers error:', error)
				Swal.fire({
					title: t('customers.list.deleteDialog.errorTitle'),
					text: t('customers.list.deleteDialog.unexpectedError'),
					icon: 'error',
				})
			} finally {
				setIsDeleting(false)
			}
		}
	}

	return {
		isDeleting,
		handleDeleteSelected,
	}
}
